"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUEST_FOLDERS_OFFICE_UID = void 0;
exports.isJwtActiveOfficeGuestFolders = isJwtActiveOfficeGuestFolders;
exports.isExplicitGuestNotaryOfficeRoleLabel = isExplicitGuestNotaryOfficeRoleLabel;
exports.shouldResolveMatrixRoleAsGuestNotary = shouldResolveMatrixRoleAsGuestNotary;
exports.resolveRealOfficeMatrixRoleFromOfficeRoleLabel = resolveRealOfficeMatrixRoleFromOfficeRoleLabel;
const rolePermissionsMatrixNormalize_1 = require("./rolePermissionsMatrixNormalize");
exports.GUEST_FOLDERS_OFFICE_UID = "GUEST_FOLDERS";
const EXPLICIT_GUEST_NOTARY_OFFICE_ROLE_KEYS = new Set([
    "notaire_invite",
    "notaire_invit",
    "guest_notary",
    "notaire_invite_permanent",
]);
function isJwtActiveOfficeGuestFolders(officeId) {
    const trimmed = officeId === null || officeId === void 0 ? void 0 : officeId.trim();
    return trimmed === exports.GUEST_FOLDERS_OFFICE_UID;
}
function isExplicitGuestNotaryOfficeRoleLabel(officeRole) {
    const key = (0, rolePermissionsMatrixNormalize_1.sanitizeMatrixKey)(officeRole);
    return key.length > 0 && EXPLICIT_GUEST_NOTARY_OFFICE_ROLE_KEYS.has(key);
}
function shouldResolveMatrixRoleAsGuestNotary(activeOfficeId, officeRole) {
    if (isJwtActiveOfficeGuestFolders(activeOfficeId)) {
        return true;
    }
    return isExplicitGuestNotaryOfficeRoleLabel(officeRole);
}
function resolveRealOfficeMatrixRoleFromOfficeRoleLabel(officeRole) {
    const key = (0, rolePermissionsMatrixNormalize_1.sanitizeMatrixKey)(officeRole);
    if (!key) {
        return null;
    }
    if (key.includes("collabor")) {
        return "collaborator";
    }
    if (key === "admin" || key.includes("administrateur")) {
        return "admin";
    }
    return null;
}
